import { useQuery } from "react-query"
import { getTotalCourse } from "../../../models/statistics"
import SummaryCard from "./SummaryCard"


const TotalCourse = () => {
    const { isLoading, isError, error, data: { data } = {} } = useQuery('statistic-total-course', getTotalCourse)

    return (
        <SummaryCard
            label="Total Courses"
            value={data?.total_course ? data.total_course.toLocaleString('id-ID') : 0}
            icon="/media/icons/duotune/abstract/abs025.svg"
            isLoading={isLoading}
            isError={isError}
            error={error}
        />
    )
}

export default TotalCourse